<div *ngIf="dependentAlreadySearched">
  <div class="header-dependente">
    <div class="values">
      <h3>{{ dependent.NomeTitular }}</h3>
      <h3 *ngIf="tipo === 'rotativo'">{{ dependent.Tag }}</h3>
      <h4>{{ dependent.NomeDoLocal }}</h4>
      <div class="value-total">
        <span>R$ {{ dependent.Saldo.toFixed(2) }}</span>
      </div>
    </div>
  </div>

  <div class="list-menu">
    <ul>
      <li *ngIf="dependent.Status.Id === 3 && tipo === 'nominal'" (click)="goTo('segundaVia')">
        <h2>
          Associar segunda via
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li *ngIf="dependent.Status.Id !== 3 && tipo === 'nominal'" (click)="goToRecarga()">
        <h2>
          Recarga
        </h2>
        <i class="icon-right-open-big"></i>
      </li>

      <li *ngIf="tipo !== 'rotativo'" (click)="goTo('limiteDiario')">
        <h2>
          Limite diário
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li *ngIf="tipo !== 'rotativo'" (click)="goTo('notificacoes')">
        <h2>
          Notificações
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li *ngIf="tipo !== 'rotativo'" (click)="goToExtrato()">
        <h2>
          Extrato
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li  *ngIf="tipo === 'rotativo'" (click)="goToExtratoRotativo()">
        <h2>
          Extrato
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li (click)="restricao()">
        <h2>
          Cardápio
        </h2>
        <i class="icon-right-open-big"></i>
      </li>

      <li *ngIf="tipo !== 'rotativo'" (click)="goToNutricional()">
        <h2>
          Nutricional
        </h2>
        <i class="icon-right-open-big"></i>
      </li>

      <li *ngIf="tipo !== 'rotativo'" routerLink="/general/alterarSenha/dependentCardName/{{ dependent.Apelido ? dependent.Apelido : 'null' }}/{{ dependent.Tag }}">
        <h2>
          Apelido do Cartão
        </h2>
        <i class="icon-right-open-big"></i>
      </li>

      <li *ngIf="dependent.Status.Id !== 3 && tipo === 'nominal'" routerLink="/general/alterarSenha/dependentPassword/{{ dependent.Tag }}/{{ dependent.Tag }}">
        <h2>
          Senha do Cartão
        </h2>
        <i class="icon-right-open-big"></i>
      </li>

      <li *ngIf="(dependent.Status.Id !== 3 && tipo === 'nominal') && dependent.EhSegundaViaCashlessEmitidaPeloLocal" (click)="goTo('duplicatePay')">
        <h2>
          Solicitar segunda via
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <li *ngIf="dependent.Status.Id !== 3 && !dependent.EhProducao && reembolsoHabilitado(dependent.TipoReembolso)" routerLink="/general/reembolso/{{ dependent.Tag }}/{{ tipo }}/{{ dependent.HistoricoAssociacaoId }}/{{ dependent.TipoReembolso.Id }}">
        <h2>
          Reembolso
        </h2>
        <i class="icon-right-open-big"></i>
      </li>
      <br>
      <br>

    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dependent-single/dependent-single.component.html